import React from "react";
import { Controller, RegisterOptions, useFormContext } from "react-hook-form";
import Select, { SelectOption } from "./Select";

interface FormSelectProps {
  name: string;
  options: SelectOption[];
  label?: string;
  placeholder?: string;
  description?: string;
  disabled?: boolean;
  rules?: RegisterOptions;
  isSearchable?: boolean;
  focusFirstOptionOnOpen?: boolean;
}

const FormSelect = ({
  name,
  options,
  label,
  placeholder,
  description,
  disabled,
  rules,
  isSearchable,
  focusFirstOptionOnOpen,
}: FormSelectProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div data-field-name={name} style={{ width: "100%" }}>
          <Select
            value={field.value ?? ""}
            onChange={field.onChange}
            options={options}
            label={label}
            placeholder={placeholder}
            description={description}
            disabled={disabled}
            error={fieldState.error?.message}
            isSearchable={isSearchable}
            focusFirstOptionOnOpen={focusFirstOptionOnOpen}
          />
        </div>
      )}
    />
  );
};

export default FormSelect;
